import { render, staticRenderFns } from "./details-comp.vue?vue&type=template&id=3bc07e20&scoped=true"
import script from "./details-comp.vue?vue&type=script&lang=js"
export * from "./details-comp.vue?vue&type=script&lang=js"
import style0 from "./details-comp.vue?vue&type=style&index=0&id=3bc07e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc07e20",
  null
  
)

export default component.exports